import { Flex, IconButton } from '@chakra-ui/react';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { Icon } from '~/ui-components';
import { Stage } from './Stage';
import { useStageEditor } from './StageEditor';

export type MoveStageControlProps = {
   stage: Stage;
};

export function MoveStageConrol({ stage }: MoveStageControlProps) {
   const stageEditor = useStageEditor();
   const { _js } = useLocalization();
   return (
      <Flex direction="column" mr={2}>
         <IconButton
            aria-label={_js('Move Stage Earlier')}
            icon={<Icon type={faArrowUp} />}
            isDisabled={!stageEditor.canMoveStageEarlier(stage)}
            onClick={() => stageEditor.moveStageEarlier(stage)}
         />
         <IconButton
            aria-label={_js('Move Stage Later')}
            icon={<Icon type={faArrowDown} />}
            isDisabled={!stageEditor.canMoveStageLater(stage)}
            onClick={() => stageEditor.moveStageLater(stage)}
         />
      </Flex>
   );
}
